import RoutesPage from "../../config/Routes";

function Main() {
  return (
    <main className="pb-10 sm:pb-14 md:pb-20 lg:pb-24">
      <RoutesPage />
    </main>
  );
}

export default Main;
